import React from "react";

/**
 * Loading.jsx
 *
 * A fullscreen page loader React component with a modern design.
 * Usage:
 * <Loading show={true} message="Loading page..." />
 */

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,0.45)",
    zIndex: 9999,
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
  },
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    padding: "24px 28px",
    borderRadius: "14px",
    background: "rgba(255,255,255,0.08)",
    color: "white",
    boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "4px solid rgba(255,255,255,0.3)",
    borderTopColor: "#60a5fa", // soft blue accent
    borderRadius: "50%",
    animation: "spin 1s ease-in-out infinite",
    boxShadow: "0 0 12px rgba(96,165,250,0.6)",
  },
  message: {
    fontSize: "16px",
    fontWeight: 500,
  },
};

// Keyframes injection
const injectSpinKeyframes = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById("loading-spin-style")) return;
  const style = document.createElement("style");
  style.id = "loading-spin-style";
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
};

export default function Loading({ show = false, message = "Loading..." }) {
  React.useEffect(() => {
    injectSpinKeyframes();
  }, []);

  if (!show) return null;

  return (
    <div style={styles.backdrop} role="status" aria-live="polite" aria-label="Loading">
      <div style={styles.center}>
        <div style={styles.spinner}></div>
        {message && <div style={styles.message}>{message}</div>}
      </div>
    </div>
  );
}